// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ChartScroll_scroll__1gNXz"};